import { useMemo } from "react";

import { ConfigurationValue } from "@plansoft-configuration-renderer/configuration-api";

import { useTableControlData } from "@/renderer/controls/CustomTable/useTableControlData";

interface SelectedValueDisplayResult {
  parsedValue: unknown;
  displayValue: unknown;
}

const parseTableValueJson = (value: string): unknown => {
  try {
    return JSON.parse(value);
  } catch (error) {
    console.error("Failed to parse value:", error);
    return value;
  }
};

export const useSelectedValueDisplay = (
  selectedValue: ConfigurationValue | null,
  displayColumnName: string | undefined,
): SelectedValueDisplayResult => {
  const { data: tableControlData } = useTableControlData({});
  const selectedValueValue = selectedValue?.value;
  const parsedValue = useMemo(() => {
    if (!displayColumnName || typeof selectedValueValue !== "string") {
      return selectedValueValue;
    }
    return parseTableValueJson(selectedValueValue);
  }, [displayColumnName, selectedValueValue]);
  const displayValue = useMemo(() => {
    if (
      tableControlData?.columns &&
      tableControlData.rows &&
      displayColumnName
    ) {
      const columnIndex = tableControlData.columns.findIndex(
        (column) => column.id === displayColumnName,
      );

      if (columnIndex !== -1 && Array.isArray(parsedValue)) {
        const selectedRow = tableControlData.rows.find(
          // TODO: [KS] Implement multiple selection handling here if needed
          (row) => row.id === parsedValue[0],
        );
        if (selectedRow && selectedRow.cells) {
          return selectedRow.cells[columnIndex]?.value;
        }
      }
    }
  }, [displayColumnName, parsedValue, tableControlData]);
  return { parsedValue, displayValue };
};
